<template>
  <div class="mob-inject">
    <template v-if="homeShow">
      <template v-if="!showAddPannel">
        <!-- 場景選擇 -->
        <scene-select :no-bg="false" @changeScene="loadScene" :sel-scene="selectScene"></scene-select>

        <div class="add-box" v-if="hotspotObj && Object.keys(hotspotObj).length === 0">
          <div class="add-inject" @click="addHotspot">{{ $t('edit.hpInfo.addHotpoint') }}</div>
        </div>
        <div class="follow-old" v-else>
          <div class="base-container">
            <div class="list-container">
              <div class="oild-list">
                <TPItem v-for="(value, k) in hotspotObj" :key="k" valueKey="hotspot_id" :itemObj="value"
                  :selectedId="currHotId" @click.native="onClickItem(value)"></TPItem>
              </div>
            </div>
            <div class="adds" @click="addHotspot" v-show="showAddBtn">
              <div>
                <img src="../../assets/img/mob_add_scene.png" />
                <h5>{{ $t('edit.hpInfo.addHotpoint') }}</h5>
              </div>
            </div>
            <!-- <div class="add-new" @click="addHotspot">
              <div class="text">{{$t('edit.hpInfo.addHotpoint').slice(0,2)}}</div>
              <div class="text">{{$t('edit.hpInfo.addHotpoint').slice(-2)}}</div>
            </div> -->
          </div>
          <!-- <div class="options" v-if="currHotId">
            <div class="options-btn" @click="editItem">{{$t('actionTitles.edit')}}</div>
            <div class="options-btn" @click="deleteItem">{{$t('actionTitles.delete')}}</div>
          </div> -->
          <!-- 編輯熱點 -->
          <edit-options v-if="editHotspotVisible" :options="options" @returnBack="closeOptions"
            @onclick="editOptions"></edit-options>
        </div>
      </template>
      <template v-else>
        <Steps :title="$t('edit.editMessage.hotPSelect')" @onClickNext="onClickNext">
          <template slot="body">
            <TextItem style="margin-left:5px" :selected="currentTypeItem.title === item.title" :title="item.title"
              v-for="(item, index) in addTitles" :key="index" @click.native="onClickType(item)"></TextItem>
          </template>
        </Steps>
      </template>
    </template>
    <template v-if="linkShow">
      <HotpLink :defaultValue="editTarget" @onClickBack="onClickBack" @saveDataToStore="saveDataToStore"
        @change="handleHotspotChange"></HotpLink>
    </template>
    <template v-if="picShow">
      <HotpPic :defaultValue="editTarget" @onClickBack="onClickBack" @saveDataToStore="saveDataToStore"
        @change="handleHotspotChange"></HotpPic>
    </template>
    <template v-if="pictextShow">
      <HotpPicText :defaultValue="editTarget" @onClickBack="onClickBack" @saveDataToStore="saveDataToStore"
        @change="handleHotspotChange"></HotpPicText>
    </template>
    <template v-if="videoShow">
      <HotpVideo :defaultValue="editTarget" @onClickBack="onClickBack" @saveDataToStore="saveDataToStore"
        @change="handleHotspotChange"></HotpVideo>
    </template>
    <template v-if="wordShow">
      <HotpWord :defaultValue="editTarget" @onClickBack="onClickBack" @saveDataToStore="saveDataToStore"
        @change="handleHotspotChange"></HotpWord>
    </template>
    <template v-if="audioShow">
      <HotpAudio :defaultValue="editTarget" @onClickBack="onClickBack" @saveDataToStore="saveDataToStore"
        @change="handleHotspotChange"></HotpAudio>
    </template>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import HotpAudio from "./component/HotpAudio";
import HotpLink from "./component/HotpLink";
import HotpPic from "./component/HotpPic";
import HotpPicText from "./component/HotpPicText";
import HotpVideo from "./component/HotpVideo";
import HotpWord from "./component/HotpWord";
import Steps from "../Steps.vue";
import TextItem from "../TextItem";
import TPItem from "../TPItem";
import SceneSelect from "../scenes/SceneSelect";
import EditOptions from "../EditOptions";

export default {
  components: { HotpAudio, HotpLink, HotpPic, HotpPicText, HotpVideo, HotpWord, Steps, TextItem, TPItem, SceneSelect, EditOptions },
  data() {
    return {
      hotspotObj: {},
      homeShow: true,
      linkShow: false,
      picShow: false,
      pictextShow: false,
      videoShow: false,
      wordShow: false,
      audioShow: false,
      isAddNew: true,
      showAddPannel: false,
      editTarget: null,
      currHotId: "",
      addTitles: [
        { title: this.$t('edit.hpInfo.linkHP'), type: "link" },
        { title: this.$t('edit.hpInfo.picture'), type: "pic" },
        { title: this.$t('edit.hpInfo.imageText'), type: "pictext" },
        { title: this.$t('edit.hpInfo.text'), type: "word" },
        { title: this.$t('edit.hpInfo.audio'), type: "audio" },
        { title: this.$t('edit.hpInfo.video'), type: "video" },
      ],
      currentTypeItem: {},
      editHotspotVisible: false,
      selectScene: [],
      options: [
        { title: this.$t('actionTitles.edit'), src: require('../../assets/img/mob_create.png'), type: 'edit' },
        { title: this.$t('actionTitles.delete'), src: require('../../assets/img/mob_delete.png'), type: 'delete' },
      ],
      showAddBtn: true,
    };
  },
  watch: {
    currentScenesId: {
      handler(newVal) {
        this.$set(this.selectScene, 0, newVal);
        this.handleInitListData();
      }
    },
  },
  created() {
    this.handleInitListData();
    this.selectScene[0] = this.currentScenesId;
  },
  computed: { ...mapGetters(["vrbase", "currentScenesId"]) },
  methods: {
    // 這裡過濾掉scene類型的數據
    handleInitListData() {
      const hotports = this.vrbase.scenes[this.currentScenesId].hotspot;
      let keys = Object.keys(hotports);
      let tempObj = {};
      for (let key in hotports) {
        if (hotports[key].type !== "scene") {
          tempObj[key] = hotports[key];
        }
      }
      this.hotspotObj = tempObj;
    },
    addHotspot() {
      this.isAddNew = true;
      this.showAddPannel = true;
      this.resetEditData();
    },
    onClickItem(value) {
      this.showAddBtn = false;
      this.editHotspotVisible = true;
      this.currHotId = value.hotspot_id;
      lookto(value.ath, value.atv);
      this.editTarget = value;
    },
    onClickType(item) {
      this.currentTypeItem = item;
    },
    onClickNext() {
      if (this.currentTypeItem.type) {
        this.handleChange(this.currentTypeItem.type);
      } else {
        this.$message.error(this.$t('edit.editMessage.hotPSelect'))
      }
    },
    handleChange(value, isAddNew = true) {
      // this.editTarget = null; // 清空選擇的編輯對像
      this.isAddNew = isAddNew;
      const typeObj = {
        scene: value === "scene",
        link: value === "link",
        pictext: value === "pictext",
        pic: value === "pic",
        video: value === "video",
        word: value === "word",
        audio: value === "audio",
      };
      this.homeShow = value === "home";
      this.sceneShow = typeObj.scene;
      this.linkShow = typeObj.link;
      this.pictextShow = typeObj.pictext;
      this.picShow = typeObj.pic;
      this.videoShow = typeObj.video;
      this.wordShow = typeObj.word;
      this.audioShow = typeObj.audio;
    },
    onClickBack() {
      this.handleChange("home");
    },
    saveDataToStore({ key, data }) {
      this.handleChange("home");
      let vrbase = this.vrbase;
      this.$set(this.hotspotObj, key, data); // 更新本地
      vrbase.scenes[this.currentScenesId].hotspot[key] = data;
      this.$store.dispatch("setVRBase", vrbase);
      this.showAddPannel = false; //增加數據後顯示增加的 數據
    },
    deleteItem() {
      const selectedItem = this.editTarget;
      let hotspot = this.vrbase.scenes[this.currentScenesId].hotspot;
      const _this = this;
      this.$confirm({
        title: _this.$t('edit.editMessage.title'),
        content: _this.$t('edit.editMessage.content'),
        okText: _this.$t('edit.editMessage.okText'),
        okType: "danger",
        cancelText: _this.$t('edit.editMessage.cancelText'),
        onOk() {
          _this.$delete(hotspot, selectedItem.hotspot_id);
          _this.$delete(_this.hotspotObj, selectedItem.hotspot_id);
          _this.$store.dispatch("setVRBase", _this.vrbase);
          removeHotspot(selectedItem.hotspot_id);
          _this.resetEditData()
        },
        onCancel() {
          console.log("取消");
        },
      });
    },
    editItem() {
      this.handleChange(this.editTarget.type, false);
    },
    handleHotspotChange(val, oldVal) {
      setHotspot(val, oldVal);
    },
    resetEditData() {
      this.currHotId = "";
      this.editTarget = null;
      this.editHotspotVisible = false;
    },
    loadScene(id) {
      this.$store.dispatch("loadScene", id);
      this.closeOptions();
    },
    //關閉編輯
    closeOptions() {
      this.editHotspotVisible = false
      this.currHotId = ''
      this.showAddBtn = true
    },
    //option的功能
    editOptions(type) {
      if (type == 'edit') {
        this.editItem()
      }
      if (type == 'delete') {
        this.deleteItem()
      }
      this.editHotspotVisible = false
      this.showAddBtn = true
    },
  },
};
</script>

<style lang="less" scoped>
.mob-inject {
  padding: 0 !important;
}
</style>
